(function productAddToCartOpenPanel() {
  if (window.MegaMacCart) {
    window.MegaMacCart._productAddToCartOpenPanel = window.MegaMacCart
      ._productAddToCartOpenPanel || { initialized: false, isAdding: false };
  }

  var state =
    (window.MegaMacCart && window.MegaMacCart._productAddToCartOpenPanel) ||
    (window.__mmProductAddToCartOpenPanelState =
      window.__mmProductAddToCartOpenPanelState || {
        initialized: false,
        isAdding: false,
      });

  if (state.initialized) return;
  state.initialized = true;

  function isCartPageFeedback() {
    var mode =
      (window.MegaMacCart &&
        window.MegaMacCart.addToCartFeedbackMode &&
        window.MegaMacCart.addToCartFeedbackMode()) ||
      'drawer';
    return mode === 'cart_page';
  }

  function setButtonBusy(btn, isBusy) {
    var opts = arguments.length > 2 ? arguments[2] : null;
    if (!btn) return;

    var shouldRestoreDisabled = !!(opts && opts.restoreDisabled === true);

    if (isBusy) {
      // Snapshot the pre-busy disabled/aria-disabled state so we can restore it later
      // without forcing the button enabled (which can conflict with variant/availability logic).
      if (btn.dataset.mmBusy === 'true') return;
      btn.dataset.mmBusy = 'true';
      btn.dataset.mmBusyPrevDisabled = btn.disabled ? '1' : '0';
      var prevAriaDisabled = btn.getAttribute('aria-disabled');
      btn.dataset.mmBusyPrevHadAriaDisabled =
        prevAriaDisabled === null ? '0' : '1';
      if (prevAriaDisabled !== null)
        btn.dataset.mmBusyPrevAriaDisabled = prevAriaDisabled;

      btn.disabled = true;
      btn.setAttribute('aria-disabled', 'true');
      btn.setAttribute('aria-busy', 'true');
      return;
    }

    // If we didn't mark this button busy, don't mutate its disabled state.
    if (btn.dataset.mmBusy !== 'true') {
      btn.removeAttribute('aria-busy');
      return;
    }

    // Always clear busy flag we own.
    btn.removeAttribute('aria-busy');

    var prevDisabled = btn.dataset.mmBusyPrevDisabled === '1';
    var prevHadAria = btn.dataset.mmBusyPrevHadAriaDisabled === '1';
    var prevAria = btn.dataset.mmBusyPrevAriaDisabled;

    try {
      delete btn.dataset.mmBusy;
      delete btn.dataset.mmBusyPrevDisabled;
      delete btn.dataset.mmBusyPrevHadAriaDisabled;
      delete btn.dataset.mmBusyPrevAriaDisabled;
    } catch (_) {}

    if (shouldRestoreDisabled) {
      btn.disabled = prevDisabled;
      if (prevHadAria) {
        btn.setAttribute('aria-disabled', prevAria || 'true');
      } else {
        btn.removeAttribute('aria-disabled');
      }
      return;
    }

    // If aria-disabled was only present because we set it while busy, remove it.
    // Do NOT touch `disabled` here: leaving it alone avoids re-enabling a button
    // that another part of the UI legitimately decided should stay disabled.
    if (!prevHadAria) {
      btn.removeAttribute('aria-disabled');
    }
  }

  function getSubmitButton(form) {
    if (!form) return null;
    var btn =
      form.querySelector('button[type="submit"][name="add"]') ||
      form.querySelector('input[type="submit"][name="add"]') ||
      form.querySelector('button[type="submit"]') ||
      form.querySelector('input[type="submit"]');
    return btn || null;
  }

  function isInputSubmit(el) {
    if (!el || !el.tagName) return false;
    var tag = String(el.tagName).toLowerCase();
    if (tag !== 'input') return false;
    var t = (el.getAttribute && el.getAttribute('type')) || el.type || '';
    return String(t).toLowerCase() === 'submit';
  }

  function snapshotSubmitButtonContent(btn) {
    if (!btn) return { kind: 'none', value: '' };
    if (isInputSubmit(btn)) {
      var v = btn.dataset.mmOriginalValue || btn.value || '';
      if (!btn.dataset.mmOriginalValue) btn.dataset.mmOriginalValue = v;
      return { kind: 'input', value: v };
    }

    var html = btn.dataset.mmOriginalHtml || btn.innerHTML || '';
    if (!btn.dataset.mmOriginalHtml) btn.dataset.mmOriginalHtml = html;
    return { kind: 'button', value: html };
  }

  function setSubmitButtonContent(btn, text) {
    if (!btn) return;
    if (isInputSubmit(btn)) {
      btn.value = text;
      return;
    }
    btn.textContent = text;
  }

  function restoreSubmitButtonContent(btn, snapshot) {
    if (!btn) return;
    var snap = snapshot || { kind: 'none', value: '' };
    if (isInputSubmit(btn)) {
      var restoreValue =
        (btn.dataset && btn.dataset.mmOriginalValue) ||
        (snap.kind === 'input' ? snap.value : '') ||
        '';
      btn.value = restoreValue;
      return;
    }

    var restoreHtml =
      (btn.dataset && btn.dataset.mmOriginalHtml) ||
      (snap.kind === 'button' ? snap.value : '') ||
      '';
    if (restoreHtml) btn.innerHTML = restoreHtml;
  }

  function getVariantIdFromForm(form) {
    if (!form) return '';
    try {
      var input = form.querySelector('input[name="id"]');
      return input && input.value ? String(input.value) : '';
    } catch (_) {
      return '';
    }
  }

  var PRODUCT_GALLERY_VISIBLE_IMG_SELECTOR = 'img.product__gallery__img';

  function isSkippableGalleryWrapper(w) {
    if (!w) return true;
    if (w.offsetParent === null) return true; // display:none or otherwise not visible
    if (w.querySelector('[data-product-gallery-video-container]')) return true;
    if (
      w.querySelector(
        'model-viewer, [data-product-gallery-model-viewer], .product__gallery__icon-3d',
      )
    )
      return true;
    return false;
  }

  function getProductGalleryImageUrlFromWrapper(w, imgSelector) {
    if (isSkippableGalleryWrapper(w)) return '';
    var imgs = w.querySelectorAll(imgSelector);
    var img = null;
    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i].offsetParent !== null) {
        img = imgs[i];
        break;
      }
    }
    if (!img) return '';
    return img.currentSrc || img.getAttribute('src') || '';
  }

  function getVisibleProductImageUrl(form) {
    try {
      if (form) {
        var tile = form.closest('.product-tile');
        if (tile) {
          var tileImg = tile.querySelector(
            'img.product-tile__img--default, img.product-tile__img',
          );
          var tileUrl =
            (tileImg && (tileImg.currentSrc || tileImg.getAttribute('src'))) ||
            '';
          if (tileUrl) return String(tileUrl);
        }
      }
    } catch (_) {}

    try {
      var gallery = document.querySelector('[data-product-gallery]');
      if (!gallery) return '';
      var wrappers = gallery.querySelectorAll('.product__gallery__img-wrapper');
      for (var i = 0; i < wrappers.length; i++) {
        var galleryUrl = getProductGalleryImageUrlFromWrapper(
          wrappers[i],
          PRODUCT_GALLERY_VISIBLE_IMG_SELECTOR,
        );
        if (galleryUrl) return String(galleryUrl);
      }
    } catch (_) {}
    return '';
  }

  async function addFormToCartAjax(form) {
    var send = function () {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
        },
        body: new FormData(form),
        credentials: 'same-origin',
      });
    };
    // Through the theme-wide queue (layout/theme.liquid), so it can't overlap a cart change from the
    // header cart panel; Shopify would lose one of them.
    var res = await (window.MegaMacCart && typeof window.MegaMacCart.queueCartRequest === 'function'
      ? window.MegaMacCart.queueCartRequest(send)
      : send());

    if (!res.ok) {
      throw new Error('Cart add failed');
    }
    return await res.json();
  }

  function getCandidateAddToCartForms() {
    var forms = [];

    try {
      var byId = document.getElementById('product-form');
      if (
        byId &&
        byId.tagName &&
        String(byId.tagName).toLowerCase() === 'form'
      ) {
        forms.push(byId);
      }
    } catch (_) {}

    try {
      // Match typical Shopify product forms + quick-add/sticky duplicates.
      // Keep this broad, but we’ll validate required fields before binding.
      var nodeList = document.querySelectorAll('form[action^="/cart/add"]');
      for (var i = 0; i < nodeList.length; i++) forms.push(nodeList[i]);
    } catch (_) {}

    // De-dupe (and drop non-elements).
    var seen = new Set();
    var out = [];
    for (var j = 0; j < forms.length; j++) {
      var f = forms[j];
      if (!f || !f.querySelector) continue;
      if (seen.has(f)) continue;
      seen.add(f);
      out.push(f);
    }
    return out;
  }

  function shouldBindToForm(form) {
    if (!form || !form.querySelector) return false;
    // Only bind if it looks like a product add form.
    if (!form.querySelector('input[name="id"]')) return false;
    if (
      !form.querySelector(
        'button[type="submit"][name="add"], input[type="submit"][name="add"]',
      )
    )
      return false;
    return true;
  }

  function isAddToCartSubmitEvent(e) {
    // Don’t hijack “Buy it now” / accelerated checkout submits when multiple submit buttons exist.
    // Modern browsers provide `e.submitter`.
    try {
      var submitter = e && e.submitter;
      if (submitter && submitter.getAttribute) {
        var name = submitter.getAttribute('name') || submitter.name || '';
        if (name && name !== 'add') return false;
      }
    } catch (_) {}
    return true;
  }

  function setCartPageAddingLabel(form) {
    var submitBtn = getSubmitButton(form);
    if (!submitBtn) return;
    snapshotSubmitButtonContent(submitBtn);
    submitBtn.setAttribute('data-mm-adding', 'true');
    setSubmitButtonContent(submitBtn, 'Adding...');
    // Disable after this submit event so the native POST is not cancelled.
    window.setTimeout(function () {
      if (!submitBtn.isConnected) return;
      if (submitBtn.getAttribute('data-mm-adding') !== 'true') return;
      submitBtn.disabled = true;
    }, 0);
  }

  function restoreAddButtonLabel() {
    state.isAdding = false;
    var buttons;
    try {
      buttons = document.querySelectorAll('[data-mm-adding="true"]');
    } catch (_) {
      return;
    }
    if (!buttons || !buttons.length) return;

    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      if (!btn) continue;

      restoreSubmitButtonContent(btn);
      btn.removeAttribute('data-mm-adding');

      if (btn.dataset && btn.dataset.mmBusy === 'true') {
        setButtonBusy(btn, false, { restoreDisabled: true });
      } else {
        btn.disabled = false;
      }
    }
  }

  function bindForm(form) {
    if (!form) return;
    if (!shouldBindToForm(form)) return;
    if (form.dataset.mmAjaxCartInit === 'true') return;
    form.dataset.mmAjaxCartInit = 'true';

    form.addEventListener('submit', function (e) {
      // If another handler already prevented default, don’t fight it.
      // (This keeps us compatible if we later add other product scripts.)
      if (e.defaultPrevented) return;
      if (!isAddToCartSubmitEvent(e)) return;

      // Native /cart/add POST: paint Adding, then let the browser navigate.
      if (isCartPageFeedback()) {
        if (state.isAdding) {
          e.preventDefault();
          return;
        }
        state.isAdding = true;
        setCartPageAddingLabel(form);
        return;
      }

      e.preventDefault();
      if (state.isAdding) return;

      var submitBtn = getSubmitButton(form);
      if (submitBtn && submitBtn.disabled) return;
      state.isAdding = true;
      var didFallbackToNativeSubmit = false;
      var variantIdAtSubmit = getVariantIdFromForm(form);
      var submittedQuantity =
        parseInt(
          (form.querySelector('input[name="quantity"]') || {}).value,
          10,
        ) || 1;
      var visibleImageUrl = getVisibleProductImageUrl(form);
      var originalBtnSnapshot = null;
      if (submitBtn) {
        originalBtnSnapshot = snapshotSubmitButtonContent(submitBtn);
        submitBtn.setAttribute('data-mm-adding', 'true');
        setSubmitButtonContent(submitBtn, 'Adding...');
      }
      setButtonBusy(submitBtn, true);

      // Store the already-visible product image so the mini-cart can reuse it
      // immediately after the AJAX add (same cache hit as the add-to-cart toast).
      try {
        var imageStore =
          window.MegaMacCart &&
          window.MegaMacCart.cartImageStore &&
          typeof window.MegaMacCart.cartImageStore.set === 'function'
            ? window.MegaMacCart.cartImageStore
            : window.MegaMacCart &&
                window.MegaMacCart.hoverImageStore &&
                typeof window.MegaMacCart.hoverImageStore.set === 'function'
              ? window.MegaMacCart.hoverImageStore
              : null;
        var variantId = getVariantIdFromForm(form);
        if (imageStore && variantId && visibleImageUrl) {
          imageStore.set(variantId, visibleImageUrl);
        }
        // Hand the stock cap to the cart panel, so its + stops at the stock for the line this add creates.
        var qtyInput = form.querySelector('input[name="quantity"]');
        var maxStore = window.MegaMacCart && window.MegaMacCart.cartMaxQtyStore;
        if (qtyInput && maxStore && variantId && qtyInput.getAttribute('data-stock-limited') === 'true') {
          maxStore.set(variantId, qtyInput.getAttribute('data-stock-qty') || '');
        }
      } catch (_) {}

      (async function () {
        var addedItem = null;
        try {
          addedItem = await addFormToCartAjax(form);
        } catch (_) {
          // Preserve correctness over UX: fall back to native flow if Ajax add fails.
          // IMPORTANT: Native submit starts a navigation. Do not clear `state.isAdding`
          // or re-enable the CTA while the browser is navigating, otherwise a second
          // submission can be triggered (double add-to-cart).
          didFallbackToNativeSubmit = true;
          try {
            form.submit();
          } catch (__) {
            window.location.href = '/cart';
          }
          return;
        }

        // Post-add operations are best-effort. If these fail, do NOT fall back to native submit,
        // otherwise we can add the item twice (AJAX succeeded, but a later step rejected).
        var cart = null;
        try {
          if (
            window.MegaMacCart &&
            typeof window.MegaMacCart.fetchCartAndEmit === 'function'
          ) {
            cart = await window.MegaMacCart.fetchCartAndEmit();
          }
        } catch (_) {}

        try {
          if (
            window.MegaMacCart &&
            typeof window.MegaMacCart.emitCartAdded === 'function'
          ) {
            window.MegaMacCart.emitCartAdded(
              cart,
              addedItem,
              submittedQuantity,
              'add',
              visibleImageUrl,
            );
          }
        } catch (_) {}
      })()
        .catch(function () {})
        .finally(function () {
          if (didFallbackToNativeSubmit) return;
          state.isAdding = false;
          var currentVariantId = getVariantIdFromForm(form);
          var variantUnchanged =
            !variantIdAtSubmit ||
            !currentVariantId ||
            String(variantIdAtSubmit) === String(currentVariantId);

          setButtonBusy(submitBtn, false, {
            restoreDisabled: variantUnchanged,
          });

          // Always revert the "Adding..." label we applied, but avoid stomping on
          // variant/availability UI updates if the button element was replaced.
          if (
            submitBtn &&
            submitBtn.isConnected &&
            submitBtn.getAttribute('data-mm-adding') === 'true'
          ) {
            restoreSubmitButtonContent(submitBtn, originalBtnSnapshot);
            submitBtn.removeAttribute('data-mm-adding');
          }

          // If the user changed variant mid-flight, ask any variant controller to re-sync
          // button state now that we're no longer busy.
          if (!variantUnchanged) {
            try {
              var idInput = form.querySelector('input[name="id"]');
              if (idInput && idInput.dispatchEvent) {
                idInput.dispatchEvent(new Event('input', { bubbles: true }));
                idInput.dispatchEvent(new Event('change', { bubbles: true }));
              }
            } catch (_) {}
          }
        });
    });
  }

  function init() {
    var forms = getCandidateAddToCartForms();
    if (!forms || !forms.length) return;
    for (var i = 0; i < forms.length; i++) bindForm(forms[i]);
  }

  // Some product UIs insert duplicate ATC forms after load (sticky bars, localized/section reloads, etc).
  // Watch for new forms and bind opportunistically.
  try {
    var scanTimer = null;
    var observer = new MutationObserver(function () {
      if (scanTimer) return;
      scanTimer = window.setTimeout(function () {
        scanTimer = null;
        init();
      }, 50);
    });
    if (document.documentElement) {
      observer.observe(document.documentElement, {
        childList: true,
        subtree: true,
      });
    }
  } catch (_) {}

  try {
    window.addEventListener('pageshow', restoreAddButtonLabel);
  } catch (_) {}

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
